export const GET_URL_STRUCTURE_M = (limit: any, skip = 0, preview: boolean) => `
query {
  pageCollection(limit: ${limit}, order: slug_ASC, skip: ${skip}, preview: ${preview}) {
    total
    items {
      title
      redirectsTo
      isContainer
      slug
      content {
        __typename
      }
      sys {
        id
      }
      childrenpagesCollection(limit: 30) {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
`;
